enum TabButtonIds {
  MAIN,
  SECOND,
  THIRD,
}

export default TabButtonIds;
